<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: null,
  },
  render(h) {
    return h('b-form-file', {
      props: {
        value: this.value,
        ...this.$attrs,
      },
      on: {
        ...this.$listeners,
        input: (val) => {
          this.$emit('input', [val]); // simulate a filelist value
        },
      },
    });
  },
};
</script>
